import { getCircleProps, Radial as RadialComponent } from './Radial';
import { Bar, BarFill } from './styles';
import { StartDirection } from './types';

const Radial = Object.assign(RadialComponent, { Bar, BarFill, StartDirection });

export { getCircleProps, Radial, StartDirection };
